import SimpleArtist from '../../../../common/types/artist/simple-artist';

export const getReleaseOwnerArtist = (release: any): SimpleArtist | undefined => {
  return release.artists.find((a: any) => a.role === 'owner')
}